import React from "react";
import Skeleton from "react-loading-skeleton";

const OverviewSkeleton = ({className}) => {

    return  <div className={`${className}`}>
              <div className="d-flex align-items-center px-3">
                <div className="d-flex flex-column flex-grow-1">
                  <Skeleton height={40} className="mb-5" />
                  <Skeleton height={300} />
                  <div className="row my-10">
                      <div className="col-md">
                        <Skeleton height={150}/>
                      </div>
                      <div className="col-md">
                        <Skeleton height={150}/>
                      </div>
                      <div className="col-md">
                        <Skeleton height={150}/>
                      </div>
                      <div className="col-md">
                        <Skeleton height={150}/>
                      </div>
                  </div>
                  <div className="row my-10">
                      <div className="col-md">
                        <Skeleton height={150}/>
                      </div>
                      <div className="col-md">
                        <Skeleton height={150}/>
                      </div>
                      <div className="col-md">
                        <Skeleton height={150}/>
                      </div>
                      <div className="col-md">
                        <Skeleton height={150}/>
                      </div>
                  </div>
                </div>
              </div>
          </div>
}

export default OverviewSkeleton;